import { Directive, Input, HostBinding } from '@angular/core';


@Directive({
  selector: '[dropdownArrowIcon]',
  exportAs: 'dropdown-arrow-icon'
})
export class DropdownArrowIconDirective {

  @HostBinding('class.dropdown-toggle') toggleClass: boolean = true;
  @HostBinding('class.dropdown-arrow') arrowClass: boolean = true;
  @HostBinding('class.dropdown-arrow-up')
  @Input()
  up: boolean = false;

  public toggle() {
    this.up = !this.up;
  }
}
